import { Anchor, Breadcrumbs, Grid, Text } from '@mantine/core';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import ErrorMessage from '../../../components/ErrorMessage';
import Metadata from '../../../components/Metadata';
import DetailedStatistics from '../../../components/Stats/DetailedStatistics';
import { Page } from '../../../constants/pageTitles';
import useFetch from '../../../helpers/useFetch';

const BannerBlocksStatisticsPage = ({ type = 'bannerBlocks' }) => {
  const page = `${Page[type]}`;
  const fetch = useFetch();
  const [bannerBlock, setBannerBlock] = useState();
  const [error, setError] = useState();
  const { accountId, domainId, id, pageId } = useParams();

  useEffect(() => {
    fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/pages/${pageId}/bannerBlocks/${id}`)
      .then(({ bannerBlock }) => setBannerBlock(bannerBlock))
      .catch(setError);
  }, [accountId, domainId, pageId, id, fetch]);

  return (
    <>
      <Metadata title={`${page} | ${bannerBlock?.name || 'Unnamed Banner Block'}`} />
      <Breadcrumbs mb="md">
        <Anchor href={`#/accounts/${accountId}/domains/${domainId}/analytics`}>Home</Anchor>
        <Anchor href={`#/accounts/${accountId}/domains/${domainId}/pages?type=${type}`}>
          {bannerBlock?.page?.name} Banner Blocks
        </Anchor>
        <Text>{bannerBlock?.name || 'Unnamed Banner Block'}</Text>
      </Breadcrumbs>

      <Grid>
        <Grid.Col span={12}>
          {error ? (
            <ErrorMessage message={error.message} />
          ) : (
            <DetailedStatistics name={bannerBlock?.name} scope="bannerBlocks" id={id} pageId={pageId} />
          )}
        </Grid.Col>
      </Grid>
    </>
  );
};

export default BannerBlocksStatisticsPage;
